module.exports = __webpack_public_path__ + "img/logo-footer.ae0c90b7.svg";